<h1 [innerHTML]="'bienvenue_sans_acces.titre' | translate"></h1>
<div class="text paragraphe">{{'bienvenue_sans_acces.texteIntro' | translate}}</div>
